import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthentication } from '../contexts/AuthenticationContext';

interface ProtectedRouteProps {
    requiredRole?: string | string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRole }) => {
    const { isAuthenticated, user, isLoading } = useAuthentication();
    const location = useLocation();

    // If auth is still loading, show a loading spinner
    if (isLoading) {
        return (
            <div className="flex h-screen items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600"></div>
            </div>
        );
    }

    // If not authenticated, redirect to login
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // If role is required, check permissions
    if (requiredRole && user) {
        const requiredRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

        if (!requiredRoles.includes(user.role)) {
            return <Navigate to="/unauthorized" replace />;
        }
    }

    // If authenticated and authorized, render the child routes
    return <Outlet />;
};

export default ProtectedRoute;